<template>
    <div class="prelative developer-page">
        <header class="flex-level mb-4 top--2 baseline">
            <h2 v-if="groupData.label && groupData.label !== ''" class="m-0">
                <slot name="header">{{ groupData.label }}</slot>
            </h2>

            <div class="ml-4">
                <tabs-nav :tabs="tabs" :activeTab="activeListing" @tab-clicked="handleSelect" />
            </div>
        </header>

        <div class="flex-column">
            <router-view v-if="!loading" :key="$route.path"></router-view>
        </div>
    </div>
</template>

<script>
import Feature from 'Services/Feature';
import TabsNav from 'vcomponents/utilities/TabsNav.vue';
import CorpId from 'vcomponents/developerPage/CorpId.vue';

export default {
    components: {
        TabsNav,
        CorpId,
    },
    props: {
        initialState: {
            type: String,
            required: false,
            default: 'my-apps',
            validator(val) {
                return ['my-apps', 'api-v2', 'third-party-apps', 'webhooks', 'widgets'].includes(
                    val,
                );
            },
        },
    },
    data() {
        return {
            loading: false,
            groupData: { label: this.$l10n.__('Développeur') },
        };
    },
    computed: {
        tabs() {
            return [
                {
                    id: "api-v2",
                    label: this.$l10n.__("API V2"),
                    route: "api-v2",
                    permission: "",
                },
                {
                    id: "my-apps",
                    label: this.$l10n.__("API"),
                    route: "my-apps",
                    permission: "",
                },
                {
                    id: "third-party-apps",
                    label: this.$l10n.__("Applications"),
                    route: "third-party-apps",
                    permission: "",
                },
                {
                    id: "webhooks",
                    label: this.$l10n.__("Webhooks"),
                    route: "webhooks",
                    permission: "",
                },
                {
                    id: "widgets",
                    label: this.$l10n.__("Widgets"),
                    route: "widgets",
                    permission: "",
                },
            ];
        },
    },
    created() {
        this.activeListing = this.$route.name;
    },
    methods: {
        handleSelect(key) {
            const listingData = this.tabs.find((listing) => listing.id === key);
            if (listingData.route != this.$router.currentRoute.value.name) {
                this.activeListing = key;
                // you can pass special props to your component with params in second paramter of the route
                // this.$router.push({ name: listingData.route, params: {prefilter: {staff : 2}}})
                this.$router.push({ name: listingData.route });
            }
        },
    },
};
</script>

<style lang="scss">
.developer-page {
    .header-actions {
        align-items: center;
        display: flex;
        position: absolute;
        right: 0;
        top: 12px;

        .el-dropdown,
        .btn {
            margin: 0 0 0 16px;
        }
    }
}
</style>
